export const SHIPPING_METHODS_MAP = {
  invaluable_shipping: 'Invaluable Shipping',
  local_pickup: 'Local Pick Up',
  arrange_your_own: 'Arrange Your Own',
};
